import { FormGroup } from '@angular/forms';
import { STATES } from '@tangilla/tg-ng-models';

export class PaymentFormTelecheckWidgetJson {
  getWidgetJson(form: FormGroup) {
    return {
      wrapperClass: 'row',
      questions: [
        {
          'type': 'checkbox',
          'name': 'TeleCheckTermsOfPayment',
          'isRequired': true,
          'requiredErrorText': 'Please agree to the Terms of Payment to continue',
          'titleLocation': 'hidden',
          class: 'col-sm-12',
          'choices': [
            {
              'value': 'PaymentTerms',
              'text': 'I acknowledge and accept the Payment Terms referenced above.'
            }
          ],
          formControl: form.get('terms_of_payment'),
          controlName: 'terms_of_payment'
        },
        ...telecheckInfo(form),
        ...personInfo(form)
      ]
    };
  }
}

const telecheckInfo = (form: FormGroup) => [
  {
    'type': 'text',
    'name': 'AccountName',
    'title': 'Account Name',
    'description': 'As it appears on your Check at (1)',
    'isRequired': true,
    class: 'col-sm-12 col-md-4',
    formControl: form.get('account_name'),
    controlName: 'account_name'
  },
  {
    'type': 'text',
    'name': 'CheckNumber',
    'title': 'Check Number',
    'includeInOutput': true,
    'requiredErrorText': 'required',
    'description': 'As it appears on your Check at (2)',
    'isRequired': true,
    placeholder: '12345678',
    mask: '09999999',
    'class': 'col-sm-12 col-md-4',
    formControl: form.get('check_number'),
    controlName: 'check_number'
  },
  {
    'type': 'text',
    'name': 'MICRNumber',
    'title': 'MICR Number',
    placeholder: '',
    'mask': '099999999999999999999999999999',
    'description': 'As it appxears on your Check at (3)',
    'isRequired': true,
    class: 'col-sm-12 col-md-4',
    formControl: form.get('micr_number'),
    controlName: 'micr_number'
  },
];

const personInfo = (form: FormGroup) => [
  {
    'type': 'text',
    'name': 'emailaddress',
    'title': 'Email Address',
    'mask': 'A*@A*.SSS',
    placeholder: '',
    'placeHolder': 'name@email.com',
    'requiredErrorText': 'required',
    'titleLocation': 'top',
    'isRequired': true,
    class: 'col-12',
    formControl: form.get('email_address'),
    controlName: 'email_address'
  },
  {
    'type': 'text',
    'name': 'DriversLicenseNumber',
    'title': 'Drivers License Number',
    'maxLength': 30,
    'titleLocation': 'top',
    'requiredErrorText': 'required',
    'isRequired': true,
    'width': '320px',
    class: 'col-sm-12 col-md-4',
    formControl: form.get('drivers_license_number'),
    controlName: 'drivers_license_number'
  },
  {
    'type': 'dropdown',
    'name': 'DriversLicenseState',
    'title': 'Drivers License State',
    'isRequired': true,
    'defaultValue': '',
    class: 'col-sm-12 col-md-4',
    'requiredErrorText': 'required',
    'choices': STATES.map(state => {
      return {
        value: state,
        label: state
      };
    }),
    'width': '320px',
    formControl: form.get('drivers_license_state'),
    controlName: 'drivers_license_state'
  },
  {
    'type': 'text',
    'name': 'DateOfBirth',
    placeholder: '',
    'mask': 'M0/d0/0000',
    'dropSpecialCharacters': false,
    'requiredErrorText': 'required',
    'defaultValue': '{birthdate}',
    'title': 'Date Of Birth',
    'isRequired': true,
    'width': '200px',
    class: 'col-sm-12 col-md-3',
    formControl: form.get('date_of_birth'),
    controlName: 'date_of_birth'
  },
  {
    'type': 'text',
    'name': 'AccountType',
    'includeInOutput': false,
    'titleLocation': 'hidden',
    'value': 'Electronic+Check',
    'visible': false
  },
];
